var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cruise-search" }, [
    _c(
      "div",
      [
        _vm.showFilters ? _c("filters") : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { ref: "results" },
          [
            _c("results", {
              attrs: {
                "max-results": _vm.maxResults,
                "promotional-results": _vm.promotionalRoutesResult,
                embedded: _vm.embedded
              },
              on: {
                scrollToTop: function($event) {
                  return _vm.$refs.results.scrollIntoView()
                }
              }
            }),
            _vm._v(" "),
            _vm.results.length === 0 && !_vm.loading
              ? _c("div", { staticClass: "no-results-message" }, [
                  _vm._v(
                    "\n\t\t\t\tPlease contact our Polar Specialists on 0203 196 1000\n\t\t\t"
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "loading-message" }, [
          _vm._v("\n\t\tUpdating Search Results...\n\t")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }